module.exports = __webpack_public_path__ + "assets/img/f64e-ga.svg";